import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
// FORÇAR ATUALIZAÇÃO - {new Date().toISOString()} - V2
import { useCurrency } from '../../contexts/CurrencyContext';
import plansImage from '../../assets/backgrounds/plans.png';
import StatsSection from '../../components/StatsSection';
import PlanFeatures from '../../components/PlanFeatures';
//import { STRIPE_PRICES } from '../../config/stripe';
import { createMoloniInvoice } from '../../services/moloni';
//import { MOLONI_PRODUCTS } from '../../config/moloni';
import './styles.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import LoginModal from '../../components/LoginModal';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Plans = () => {
  const { currency, currencySymbol, exchangeRate } = useCurrency();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactFormSubmitted, setContactFormSubmitted] = useState(false);
  const [contactForm, setContactForm] = useState({
    nome: '',
    email: '',
    telefone: '',
    numImoveis: '',
    pais: '',
    assunto: '',
    mensagem: ''
  });
  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [userData, setUserData] = useState(null);
  const [promotionCode, setPromotionCode] = useState('');
  const [showUrgencyModal, setShowUrgencyModal] = useState(false);
  const [showTimeExpiredModal, setShowTimeExpiredModal] = useState(false);
  const [userClosedUrgencyModal, setUserClosedUrgencyModal] = useState(false);
  const [userClosedTimeExpiredModal, setUserClosedTimeExpiredModal] = useState(false);
  const [timeExpiredModalOpenedAt, setTimeExpiredModalOpenedAt] = useState(null);
  // const [slotsLeft, setSlotsLeft] = useState(100); // DESATIVADO - sistema de milestones
  const [isSoldOut, setIsSoldOut] = useState(false);
  const [couponData, setCouponData] = useState(null);
  const [promocao, setPromocao] = useState(null);
  const [couponLoading, setCouponLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const timerRef = useRef(null);
  const countdownRef = useRef(null);
  // Variáveis do sistema de milestones - DESATIVADO POR ENQUANTO
  // const shownMilestonesRef = useRef(new Set());
  // const [milestoneMessage, setMilestoneMessage] = useState('');
  // const [showMilestonePopup, setShowMilestonePopup] = useState(false);
  const [promotionEndedTimestamp, setPromotionEndedTimestamp] = useState(null);
  const [showPlanUsedPopup, setShowPlanUsedPopup] = useState(false);
  const [planUsedPopupType, setPlanUsedPopupType] = useState('redeemed'); // 'redeemed' or 'professional'
  const [userRole, setUserRole] = useState(null);
  // Traduz o valor do tab para o valor esperado do backend
  function tabLabelToTipo(tab) {
    if(tab === 'professional') return 'Profissional';
    if(tab === 'particular') return 'Particular';
    if(tab === 'ferias') return 'Férias';
    return tab;
  }

  // Detectar o perfil do usuário a partir do localStorage
  useEffect(() => {
    try {
      const rawUser = localStorage.getItem('user');
      const rawCurrentUser = localStorage.getItem('current_user');
      const authRole = localStorage.getItem('auth_role');
      const norm = (s) => (s || '').toString().trim().toUpperCase();
      const tokenize = (s) => norm(s).split(/[^A-Z]+/).filter(Boolean);
      const adminAliases = new Set(['ADMIN', 'ADMINISTRADOR', 'ADMINISTRATOR', 'SUPERADMIN', 'SUPER_ADMIN', 'ROOT']);

      const authTokens = tokenize(authRole || '');
      const userObj = rawUser ? JSON.parse(rawUser) : {};
      const currentUserObj = rawCurrentUser ? JSON.parse(rawCurrentUser) : {};
      const userRoleRaw = userObj.perfil || userObj.perfilUSUARIO || userObj.role || userObj.tipo || userObj.nivel || userObj.papel || '';
      const currentUserRoleRaw = currentUserObj.perfil || currentUserObj.perfilUSUARIO || currentUserObj.role || currentUserObj.tipo || currentUserObj.nivel || currentUserObj.papel || '';
      const userTokens = tokenize(userRoleRaw);
      const currentUserTokens = tokenize(currentUserRoleRaw);

      // Decodifica JWT (base64url) e tenta extrair possíveis campos de role
      const authToken = localStorage.getItem('auth_token');
      let jwtRole = '';
      if (authToken) {
        try {
          const parts = authToken.split('.');
          if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1]));
            jwtRole = payload.role || payload.perfil || payload.perfilUSUARIO || payload.tipo || payload.nivel || payload.papel || '';
          }
        } catch (e) { console.error('Erro ao decodificar JWT:', e); }
      }
      const jwtTokens = tokenize(jwtRole);

      const allTokens = [...authTokens, ...userTokens, ...currentUserTokens, ...jwtTokens];
      let detectedRole = 'PARTICULAR';
      if (allTokens.some(t => adminAliases.has(t))) {
        detectedRole = 'ADMIN';
      } else if (allTokens.some(t => t === 'PROFISSIONAL')) {
        detectedRole = 'PROFISSIONAL';
      } else if (allTokens.some(t => t === 'EMPREENDIMENTO')) {
        detectedRole = 'EMPREENDIMENTO';
      } else if (allTokens.some(t => t === 'PARTICULAR')) {
        detectedRole = 'PARTICULAR';
      }
      setUserRole(detectedRole);
    } catch (e) {
      console.error('Erro ao detectar perfil do usuário:', e);
      setUserRole('PARTICULAR');
    }
  }, []);

  // Carregar timestamp de fim de promoção do localStorage
  useEffect(() => {
    try {
      // Limpar chaves antigas de teste
      localStorage.removeItem('test_promotion_end_time');
      // Limpar chave legada: o fim da promoção agora vem da API (/api/promocoes/ativa)
      localStorage.removeItem('promotion_end_time');
      
      const savedTimestamp = localStorage.getItem('promotion_ended_timestamp');
      if (savedTimestamp) {
        setPromotionEndedTimestamp(Number(savedTimestamp));
      }
    } catch (e) {
      console.error('Erro ao carregar timestamp de promoção:', e);
    }
  }, []);

  // Carregar estado do modal de tempo expirado do localStorage
  useEffect(() => {
    try {
      const savedState = localStorage.getItem('time_expired_modal_closed');
      if (savedState === '1') {
        setUserClosedTimeExpiredModal(true);
      }
    } catch (e) {
      console.error('Erro ao carregar estado do modal:', e);
    }
  }, []);

  // Atualizar temporizador a cada segundo
  useEffect(() => {
    if (!couponData || !couponData.dataFim) {
      setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0, expired: true });
      return;
    }

    const targetEndTime = new Date(couponData.dataFim);

    const calculateTimeLeft = () => {
      const agora = new Date();
      const diferenca = targetEndTime - agora;

      if (diferenca <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
      }

      const days = Math.floor(diferenca / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diferenca % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diferenca % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diferenca % (1000 * 60)) / 1000);

      return { days, hours, minutes, seconds, expired: false };
    };

    const initialTimeLeft = calculateTimeLeft();
    setTimeLeft(initialTimeLeft);

    if (initialTimeLeft.expired) {
      return;
    }

    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      if (newTimeLeft.expired) {
        clearInterval(interval);
        if (!promotionEndedTimestamp) {
          const now = Date.now();
          setPromotionEndedTimestamp(now);
          setPromotionCode('');
          try {
            localStorage.setItem('promotion_ended_timestamp', String(now));
          } catch (e) {
            console.error('Erro ao salvar timestamp de promoção:', e);
          }
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [couponData, promotionEndedTimestamp]);

  // Handle do formulário de contato
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    
    // Validar campos antes de enviar
    const validations = {
      nome: contactForm.nome?.trim().length > 0,
      email: contactForm.email?.trim().length > 0 && contactForm.email?.includes('@'),
      telefone: contactForm.telefone?.trim().length > 0,
      numImoveis: contactForm.numImoveis?.trim().length > 0,
      pais: contactForm.pais?.trim().length > 0,
      assunto: contactForm.assunto?.trim().length > 0
    };
    
    const invalidFields = Object.entries(validations)
      .filter(([, isValid]) => !isValid)
      .map(([field]) => field);
    
    if (invalidFields.length > 0) {
      alert(`Por favor, preencha corretamente: ${invalidFields.join(', ')}`);
      return;
    }
    
    setIsSubmittingContact(true);
    
    try {
      const requestData = {
        nome: contactForm.nome.trim(),
        email: contactForm.email.trim(),
        telefone: contactForm.telefone.trim(),
        numImoveis: contactForm.numImoveis.trim(),
        pais: contactForm.pais.trim(),
        assunto: contactForm.assunto.trim(),
        mensagem: contactForm.mensagem?.trim() || '',
        departamento: 'comercial',
        tipoPlano: 'Profissional',
        periodo: billingPeriod === '30d' ? 'Mensal' : 'Anual'
      };
      
      const response = await fetch(`${import.meta.env.VITE_URL_API}/propostapersonalizada`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      const resultado = await response.json();
      
      if (response.ok) {
        setContactFormSubmitted(true);
      } else {
        alert(resultado.message || 'Erro ao enviar mensagem. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao enviar contato:', error);
      alert('Erro ao enviar mensagem. Tente novamente.');
    } finally {
      setIsSubmittingContact(false);
    }
  };

  const handleContactInputChange = (e) => {
    setContactForm({
      ...contactForm,
      [e.target.name]: e.target.value
    });
  };

  const closeContactModal = () => {
    setShowContactModal(false);
    setContactFormSubmitted(false);
    setContactForm({
      nome: '',
      email: '',
      telefone: '',
      numImoveis: '',
      pais: '',
      assunto: '',
      mensagem: ''
    });
  };

  const openContactModal = () => {
    if (userData) {
      const paisCodigo = userData.paisUSUARIO || userData.country;
      // Mapeamento de códigos para nomes (mesmo formato do Profile)
      const paisMap = {
        1: 'PT',
        6: 'BR',
        2: 'ES',
        3: 'FR',
        4: 'DE',
        5: 'IT',
        7: 'US',
        8: 'GB',
        9: 'CA',
        10: 'AU'
      };
      const paisIso = paisMap[Number(paisCodigo)] || '';
      
      const telefone = userData.numeroprincipalUSUARIO || userData.telefone || userData.phone || '';
      const prefixo = userData.prefixoUSUARIO || userData.prefix || '';
      const telefoneCompleto = prefixo && telefone ? `${prefixo}${telefone}` : telefone;

      setContactForm(prev => ({
        ...prev,
        nome: userData.nomeUSUARIO || userData.nome || userData.name || '',
        email: userData.emailUSUARIO || userData.email || '',
        telefone: telefoneCompleto,
        pais: paisIso,
        assunto: billingPeriod === '30d' ? 'Proposta Plano Pro Max' : 'Proposta Plano Business +'
      }));
    }
    setShowContactModal(true);
  };

  const [planType, setPlanType] = useState('professional');
  // Para planos profissionais, usamos períodos explícitos baseados em dias: 30, 90, 180, 365
  // Valores possíveis: '30d', '3m', '6m', '12m'
  const [billingPeriod, setBillingPeriod] = useState('30d');

  const goToCadastro = () => {
    navigate('/cadastro/hostd');
  };

  const handleCustomProposalClick = () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      goToCadastro();
      return;
    }
    openContactModal();
  };

  // Restaurar estado do plano selecionado a partir dos parâmetros da URL
  useEffect(() => {
    const typeParam = searchParams.get('type');
    const periodParam = searchParams.get('period');

    if (typeParam && ['professional', 'particular', 'ferias'].includes(typeParam)) {
      setPlanType(typeParam);
    }
    if (periodParam && ['30d', '3m', '6m', '12m'].includes(periodParam)) {
      setBillingPeriod(periodParam);
    }
  }, [searchParams]);
  // A promoção ativa (da API) define em quais abas o countdown/urgência aparece
  const isTargetPlan = !!promocao && (
    (planType === 'professional' && billingPeriod === '12m' && !!promocao.aplicaProfissional12mPROMOCAO) ||
    (planType === 'ferias' && !!promocao.aplicaFeriasPROMOCAO)
  );

  const [isLoading, setIsLoading] = useState(false);
  const [isPeriodChanging, setIsPeriodChanging] = useState(false);
  const [processingPlanIndex, setProcessingPlanIndex] = useState(null);
  const [error, setError] = useState(null);
  // Estado global (frontend) para bloquear qualquer plano gratuito após resgate
  const [freePlanRedeemed, setFreePlanRedeemed] = useState(false);

  // Estado para armazenar os planos vindos da API
  const [apiPlans, setApiPlans] = useState([]);

  // Busca os planos da API ao montar ou trocar o tipo de plano
  useEffect(() => {
    setIsLoading(true);
    setError(null);
    // URL correta da API de planos
    fetch(`${import.meta.env.VITE_URL_API}/planos`)
      .then(res => res.json())
      .then(data => {
        setApiPlans(Array.isArray(data) ? data : []);
        setIsLoading(false);
      })
      .catch(err => {
        setError('Erro ao carregar planos: ' + err.message);
        setIsLoading(false);
      });
  }, [planType]);

  // Busca dados do usuário logado
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        if (!token) return;

        // Decodificar o token para pegar o ID do usuário
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) return;
        
        const payload = JSON.parse(atob(tokenParts[1]));
        const userId = payload.codigo || payload.id || payload.userId;
        
        if (!userId) return;

        const res = await fetch(`${import.meta.env.VITE_URL_API}/usuarios/${userId}`, {
          headers: {
            accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        
        if (res.ok) {
          const data = await res.json();
          setUserData(data);
        }
      } catch (err) {
        console.error('Erro ao buscar dados do usuário', err);
      }
    };

    fetchUserData();
  }, []);

  // Sistema de contador baseado na promoção ativa vinda da API
  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (countdownRef.current) clearInterval(countdownRef.current);

    const fetchCouponData = async () => {
      setCouponLoading(true);
      try {
        const response = await fetch(`${import.meta.env.VITE_URL_API}/promocoes/ativa`);
        const data = await response.json();

        if (response.ok) {
          const ativa = data.promocao || null;
          setPromocao(ativa);

          if (ativa) {
            setCouponData({
              ...data,
              dataFim: ativa.dataFimPROMOCAO,
              dataInicio: ativa.dataInicioPROMOCAO
            });
            const restante = data.uso?.totalRestante || 0;
            setIsSoldOut(restante <= 0);

            // Graça de 24h pós-expiração deriva da dataFim da promoção.
            // Se a promoção voltou a ficar ativa, limpa o timestamp legado.
            if (data.encerrado) {
              const fim = new Date(ativa.dataFimPROMOCAO).getTime();
              setPromotionCode('');
              try {
                localStorage.setItem('promotion_ended_timestamp', String(fim));
              } catch (e) {
                console.error('Erro ao salvar timestamp de promoção:', e);
              }
              setPromotionEndedTimestamp((prev) => prev || fim);
            } else {
              try {
                localStorage.removeItem('promotion_ended_timestamp');
              } catch (e) {
                console.error('Erro ao limpar timestamp de promoção:', e);
              }
              setPromotionEndedTimestamp((prev) => (prev ? null : prev));
            }
          } else {
            setCouponData(null);
            setIsSoldOut(false);
            try {
              localStorage.removeItem('promotion_ended_timestamp');
            } catch (e) {
              console.error('Erro ao limpar timestamp de promoção:', e);
            }
            setPromotionEndedTimestamp((prev) => (prev ? null : prev));
          }
        }
      } catch (error) {
        console.error('Erro ao buscar promoção ativa:', error);
      } finally {
        setCouponLoading(false);
      }
    };

    fetchCouponData();

    countdownRef.current = setInterval(() => {
      fetchCouponData();
    }, 30000);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
  }, [planType, billingPeriod]);

  // Efeito para mostrar modal quando há vagas limitadas
  useEffect(() => {
    if (couponData && !couponLoading) {
      if (isTargetPlan && !userClosedUrgencyModal) {
        // Mostrar modal após 2 segundos
        timerRef.current = setTimeout(() => {
          setShowUrgencyModal(true);
        }, 2000);
      }
    }
  }, [couponData, couponLoading, isTargetPlan, userClosedUrgencyModal]);

  // Efeito para mostrar modal quando o tempo expirar
  useEffect(() => {
    // Condição real de expiração: dataFim da promoção já passou.
    // Evita disparo no estado transitório em que timeLeft.expired=true
    // antes dos dados da promoção chegarem da API.
    const fimPassou = !!couponData?.dataFim && Date.now() >= new Date(couponData.dataFim).getTime();
    if (promocao && isTargetPlan && fimPassou && !showTimeExpiredModal && !userClosedTimeExpiredModal) {
      setShowTimeExpiredModal(true);
      setTimeExpiredModalOpenedAt(Date.now());
      // Fechar o modal verde quando o vermelho abrir
      setShowUrgencyModal(false);
    }
  }, [promocao, couponData, isTargetPlan, timeLeft.expired, showTimeExpiredModal, userClosedTimeExpiredModal]);

  // Efeito para fechar automaticamente o modal após 48 horas
  useEffect(() => {
    if (showTimeExpiredModal && timeExpiredModalOpenedAt) {
      const hours48 = 48 * 60 * 60 * 1000; // 48 horas em milissegundos
      const timeSinceOpened = Date.now() - timeExpiredModalOpenedAt;
      
      if (timeSinceOpened >= hours48) {
        setShowTimeExpiredModal(false);
        setUserClosedTimeExpiredModal(true);
        try {
          localStorage.setItem('time_expired_modal_closed', '1');
        } catch (e) {
          console.error('Erro ao salvar estado do modal:', e);
        }
      } else {
        const remainingTime = hours48 - timeSinceOpened;
        const timeoutId = setTimeout(() => {
          setShowTimeExpiredModal(false);
          setUserClosedTimeExpiredModal(true);
          try {
            localStorage.setItem('time_expired_modal_closed', '1');
          } catch (e) {
            console.error('Erro ao salvar estado do modal:', e);
          }
        }, remainingTime);
        
        return () => clearTimeout(timeoutId);
      }
    }
  }, [showTimeExpiredModal, timeExpiredModalOpenedAt]);

  // Efeito para mostrar pop-ups de milestones
  // DESATIVADO POR ENQUANTO
  /*
  useEffect(() => {
    const milestones = [65, 50, 40, 15, 10, 5, 3, 2, 1, 0];
    
    if (milestones.includes(slotsLeft) && !shownMilestonesRef.current.has(slotsLeft)) {
      shownMilestonesRef.current.add(slotsLeft);
      
      if (slotsLeft === 0) {
        setMilestoneMessage('FOI PENA TERES PERDIDO ESTA COMPRA COM ESTES PREÇOS, MAS BREVEMENTE, TEREMOS MAIS NOVIDADES.\nFICA ATENTO');
        setShowMilestonePopup(true);
      } else {
        setMilestoneMessage(`Só faltam ${slotsLeft} vagas!`);
        setShowMilestonePopup(true);
        
        // Fechar automaticamente após 5 segundos
        timerRef.current = setTimeout(() => {
          setShowMilestonePopup(false);
        }, 5000);
      }
    }
  }, [slotsLeft]);
  */



  const handlePlanTypeChange = (newType) => {
    setIsLoading(true);
    setPlanType(newType);
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  };

  const handlePeriodChange = (newPeriod) => {
    setIsPeriodChanging(true);
    setTimeout(() => {
      setBillingPeriod(newPeriod);
      setIsPeriodChanging(false);
    }, 300);
  };

  const handlePlanSelection = async (plan, index, couponCode = null) => {
    try {
      setProcessingPlanIndex(index);
      setError(null);

      // Determinar o priceId correto com base no tipo de plano e período
      let priceId;
      let moloniProductId;

      priceId = plan.stripeidPLANO
      moloniProductId = plan.moloniidPLANO
      /* 
      if (planType === 'professional') {
        const planKey = `${plan.subtitle.split(' ')[0]}_imoveis`.toLowerCase();
        priceId = STRIPE_PRICES.professional[billingPeriod][planKey];
        moloniProductId = MOLONI_PRODUCTS.professional[billingPeriod][planKey];
      } else if (planType === 'particular') {
        const duration = plan.subtitle.replace(' ', '_').toLowerCase();
        priceId = STRIPE_PRICES.particular[duration];
        moloniProductId = MOLONI_PRODUCTS.particular[billingPeriod];
      } else if (planType === 'ferias') {
        const duration = plan.subtitle.replace(' ', '_').toLowerCase();
        const key = plan.features[1].includes('12 imóveis') 
          ? '12_meses_12_imoveis' 
          : duration;
        priceId = STRIPE_PRICES.ferias[key];
        moloniProductId = MOLONI_PRODUCTS.ferias[key];
      }
 */

      if (!priceId || !moloniProductId) {
        throw new Error('Price ID ou Product ID não encontrado para este plano');
      }

      // Verifica se é plano gratuito (valor ou valor promocional igual a 0)
      const baseValue = Number(plan?.promoPLANO || 0) > 0
        ? Number(plan.promoPLANO)
        : (Number(plan?.valorPromocionalPLANO || 0) > 0
          ? Number(plan.valorPromocionalPLANO)
          : Number(plan?.valorPLANO || 0));
      const isFreePlan = baseValue === 0;

      // Bloqueio de plano gratuito para perfil PROFISSIONAL
      if (isFreePlan && userRole === 'PROFISSIONAL') {
        setPlanUsedPopupType('professional');
        setShowPlanUsedPopup(true);
        return;
      }

      // Impede segunda compra de plano gratuito
      const alreadyRedeemed = localStorage.getItem('free_plan_redeemed') === '1';
      if (isFreePlan && alreadyRedeemed) {
        setPlanUsedPopupType('redeemed');
        setShowPlanUsedPopup(true);
        return;
      }

      // Marca como resgatado IMEDIATAMENTE no frontend (bloqueio estrito)
      if (isFreePlan) {
        try {
          localStorage.setItem('free_plan_pending', '1');
          localStorage.setItem('free_plan_redeemed', '1');
          setFreePlanRedeemed(true);
        } catch (e) { console.error(e); }
      }

      // Usar o código do cupom passado como parâmetro ou o estado
      const codeToUse = couponCode || promotionCode;

      // Gravar uso do cupom na API (se houver cupom informado)
      if (codeToUse && codeToUse.trim() !== '') {
        try {
          const token = localStorage.getItem('auth_token');
          const userId = localStorage.getItem('user_id'); // Assumindo que o ID do usuário está armazenado

          if (token) {
            await fetch(`${import.meta.env.VITE_URL_API}/cupons/usar`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify({
                codigoCupomSTR: codeToUse.trim().toUpperCase(),
                codigoUSUARIO: userId ? Number(userId) : null
              })
            });
          }
        } catch (error) {
          console.error('Erro ao gravar uso do cupom:', error);
          // Não bloqueia a compra se falhar ao gravar o uso
        }
      }

      // O cupom é independente das promoções: sempre envia o código informado
      // (digitado manualmente ou via botão de cupom do plano)
      const finalPromotionCode = codeToUse;

      // Criar sessão do Stripe (import dinâmico para evitar carregar Stripe fora desta tela)
      const { createCheckoutSession } = await import('../../services/stripe');
      const session = await createCheckoutSession(priceId, finalPromotionCode, {
        page: '/plans',
        type: planType,
        period: billingPeriod
      });
      
      // Após o pagamento bem-sucedido, criar fatura na Moloni
      if (session) {
        const customerData = {
          name: session.customer.name,
          email: session.customer.email,
          taxNumber: session.customer.tax_number,
          address: session.customer.address,
          city: session.customer.city,
          postalCode: session.customer.postal_code,
          country: session.customer.country
        };

        const planData = {
          productId: moloniProductId,
          price: plan.price,
          description: `${plan.title} - ${plan.subtitle}`
        };

        await createMoloniInvoice(customerData, planData);
      }
    } catch (error) {
      console.error('Erro detalhado ao processar pagamento:', {
        message: error.message,
        stack: error.stack,
        error
      });
      const msg = String(error?.message || '').toLowerCase();
      setError(`Erro ao processar pagamento: ${error.message}`);
      if (msg.includes('não autorizado') || msg.includes('401')) {
        // Abre modal de login automaticamente em caso de 401
        setShowLoginModal(true);
      }
    } finally {
      setProcessingPlanIndex(null);
    }
  };

  useEffect(() => {
    document.body.classList.add('plans-page');
    return () => {
      document.body.classList.remove('plans-page');
    };
  }, []);

  // Inicializa flag de bloqueio do plano gratuito a partir do localStorage
  useEffect(() => {
    try {
      setFreePlanRedeemed(localStorage.getItem('free_plan_redeemed') === '1');
    } catch (e) { console.error(e); }
  }, []);

  // Reset billing period when changing plan type
  useEffect(() => {
    setBillingPeriod('30d');
    setUserClosedUrgencyModal(false);
    // Não resetar o modal de tempo expirado - deve persistir
    // setUserClosedTimeExpiredModal(false);
  }, [planType]);

  // Reset urgency modal flag when changing billing period
  useEffect(() => {
    setUserClosedUrgencyModal(false);
    // Não resetar o modal de tempo expirado - deve persistir
    // setUserClosedTimeExpiredModal(false);
  }, [billingPeriod]);

  return (
    <div className="plans-page">
      <div className="hero-section">
        <img src={plansImage} alt="Planos JoviPlanet" />
        <div className="hero-content">
          <div className="hero-titles">
            <h1>
              {planType === 'ferias' 
                ? 'Anuncie o seu imóvel de férias e alcance milhões de viajantes!'
                : planType === 'particular'
                ? 'Anunciar na Joviplanet é mais fácil e acessível do que você imagina!'
                : 'Anunciar na Joviplanet é mais fácil e acessível do que você imagina!'
              }
            </h1>
            <p style={{ fontSize: '18px' }}>
              {planType === 'ferias'
                ? 'Descubra as melhores opções para anunciar o seu imóvel de férias e comece a rentabilizar o seu patrimônio agora mesmo.'
                : planType === 'particular'
                ? 'Adquira o plano que melhor se adapta às suas necessidades'
                : 'Adquira o plano que melhor se adapta às suas necessidades'
              }
            </p>
          </div>
          <div className="plan-type-selector">
            <button 
              className={planType === 'professional' ? 'active' : ''}
              onClick={() => handlePlanTypeChange('professional')}
            >
              Profissional
            </button>
            <button 
              className={planType === 'particular' ? 'active' : ''} 
              onClick={() => handlePlanTypeChange('particular')}
            >
              Particular
            </button>
            <button 
              className={planType === 'ferias' ? 'active' : ''} 
              onClick={() => handlePlanTypeChange('ferias')}
            >
              Férias
            </button>
          </div>
        </div>
      </div>
      <div className="plans-container">
        <div className="plans-header">
          <div className="plan-type-indicator">
            <span className="plan-type-value">
              {planType === 'professional' ? 'Profissional' : planType === 'particular' ? 'Particular' : 'Férias'}
            </span>
          </div>

          <div className="coupon-box">
              <input
                className="coupon-input"
                type="text"
                value={promotionCode}
                onChange={(e) => setPromotionCode(e.target.value)}
                placeholder="Cupom de desconto"
                autoComplete="off"
              />
            </div>

          {planType === 'professional' && (
            <div className="billing-toggle">
              <button
                className={billingPeriod === '30d' ? 'active' : ''}
                onClick={() => handlePeriodChange('30d')}
              >
                Mensal
              </button>
              <button
                className={billingPeriod === '12m' ? 'active' : ''}
                onClick={() => handlePeriodChange('12m')}
              >
                <span>Anual</span>
                <span className="billing-tag">Recomendado</span>
              </button>
            </div>
          )}
        </div>
        <div className={`plans-content ${isLoading || isPeriodChanging ? 'fade-out' : 'fade-in'}`}>
          {(isLoading || isPeriodChanging) && <span className="loader"></span>}

          {(planType === 'ferias' || (planType === 'professional' && billingPeriod === '12m')) && (
            <div className="no-commission-banner">Sem comissões. Apenas crescimento</div>
          )}
          {error && !error.includes('plano gratuito') && (
            <div className="error-message">{error}</div>
          )}

          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={25}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            }}
            className="plans-swiper"
          >

            {(() => {
              function normalizeString(str) {
                return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
              }

              let filtered = apiPlans.filter((planoApi) => {
                const isProfessional = planType === 'professional' && planoApi.tipoPlano && normalizeString(planoApi.tipoPlano.planoTIPOPLANO) === 'profissional';
                
                if (isProfessional) {
                  const days = Number(planoApi.tempoPLANO) || 0;
                  if (billingPeriod === '30d') return days === 30 && planoApi.ativoPLANO === true && planoApi.tipoPlano.ativoTIPOPLANO === 1;
                  if (billingPeriod === '3m') return days === 90 && planoApi.ativoPLANO === true && planoApi.tipoPlano.ativoTIPOPLANO === 1;
                  if (billingPeriod === '6m') return days === 180 && planoApi.ativoPLANO === true && planoApi.tipoPlano.ativoTIPOPLANO === 1;
                  if (billingPeriod === '12m') return days === 365 && planoApi.ativoPLANO === true && planoApi.tipoPlano.ativoTIPOPLANO === 1;
                  return false;
                }
                
                return (
                  planoApi.ativoPLANO === true &&
                  planoApi.tipoPlano &&
                  normalizeString(planoApi.tipoPlano.planoTIPOPLANO) === normalizeString(tabLabelToTipo(planType)) &&
                  planoApi.tipoPlano.ativoTIPOPLANO === 1
                );
              });

              if (filtered.length > 1) {
                const destaqueIndex = filtered.findIndex(p => p.destaquePLANO === 1);
                if (destaqueIndex > 0) {
                  const [destaquePlano] = filtered.splice(destaqueIndex, 1);
                  filtered.unshift(destaquePlano);
                }
              }

              filtered.sort((a, b) => {
                const ordemA = a.ordemPLANO ?? 9999;
                const ordemB = b.ordemPLANO ?? 9999;
                return ordemA - ordemB;
              });

              if (planType === 'ferias') {
                const hasOneMonth = filtered.some((p) => {
                  const days = Number(p?.tempoPLANO || 0);
                  const name = String(p?.nomePLANO || '').toLowerCase();
                  return days === 30 || name.includes('1 mês') || name.includes('30 dias');
                });
                if (!hasOneMonth) {
                  filtered.unshift({
                    idPLANO: 'ferias-1m-fallback',
                    nomePLANO: 'Plano 1 mês',
                    subtituloPLANO: '',
                    tempoPLANO: 30,
                    valorPLANO: 0,
                    valorPromocionalPLANO: 0,
                    ativoPLANO: true,
                    tipoPlano: { planoTIPOPLANO: 'Férias', ativoTIPOPLANO: 1 },
                    descritivosPLANO: []
                  });
                }
              }

              const normalizedPlans = filtered.map((p) => {
                const rawNome = String(p?.nomePLANO || '');
                const matchImoveis = rawNome.match(/\d[\d.]*\s*Im[oó]ve(?:l|is)\s*$/i);
                if (!matchImoveis) return p;
                const title = rawNome
                  .slice(0, matchImoveis.index)
                  .replace(/(\s|<br\s*\/?\s*>|,|–|—|-)+$/i, '');
                if (!title) return p;
                return { ...p, nomePLANO: `${title}<br>${matchImoveis[0].trim()}` };
              });

              return normalizedPlans.map((planoApi, index) => (
                <SwiperSlide key={planoApi.idPLANO || index}>
                  <div
                    className={`plan-card ${planoApi.destaquePLANO === 1 ? 'destaque' : ''}`}
                    style={{ position: 'relative' }}
                  >
                    <h3 dangerouslySetInnerHTML={{ __html: planoApi.nomePLANO }} />
                    <h4>{planoApi.subtituloPLANO}</h4>
                    <div className="price">
                      {(() => {
                        // Verificar se o cronômetro ainda está ativo ou se está dentro das 24h após expiração
                        const isTimerActive = timeLeft.days > 0 || timeLeft.hours > 0 || timeLeft.minutes > 0 || timeLeft.seconds > 0;
                        const isWithin24Hours = promotionEndedTimestamp && (Date.now() - promotionEndedTimestamp) < (24 * 60 * 60 * 1000);
                        const isPromotionActive = isTimerActive && !isWithin24Hours;
                        const hasPromo = Number(planoApi?.promoPLANO || 0) > 0;
                        // Se o cronômetro encerrou ou está nas 24h após, usar preço normal, ignorar promoções
                        const valueBase = (hasPromo && isPromotionActive)
                          ? Number(planoApi.promoPLANO)
                          : (Number(planoApi?.valorPromocionalPLANO || 0) > 0 && isPromotionActive
                            ? Number(planoApi.valorPromocionalPLANO)
                            : Number(planoApi?.valorPLANO || 0));
                        const isFreeItem = valueBase === 0;
                        if (isFreeItem) {
                          if (planType === 'ferias') {
                            const value = 39.00;
                            const convertedValue = value * exchangeRate;
                            const formattedValue = new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: currency,
                            }).format(convertedValue);
                            
                            // Usar o símbolo da moeda do contexto
                            return (
                              <span>
                                <span className="currency-symbol">{currencySymbol}</span>
                                <span className="amount">{formattedValue.replace(/[^\d.,]/g, '')}</span>
                              </span>
                            );
                          } else {
                            return <span>Gratuito</span>;
                          }
                        }
                        
                        // Se tem promoção E cronômetro está ativo, mostra preço original tachado e preço promocional
                        // Se a promoção expirou (dentro de 24h), mostra preço promocional tachado e preço normal
                        if (hasPromo && (isTimerActive || isWithin24Hours)) {
                          const originalValue = Number(planoApi.valorPLANO);
                          const promoValue = Number(planoApi.promoPLANO);
                          
                          const convertedOriginal = originalValue * exchangeRate;
                          const convertedPromo = promoValue * exchangeRate;
                          
                          const formattedOriginal = new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: currency,
                          }).format(convertedOriginal);
                          
                          const formattedPromo = new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: currency,
                          }).format(convertedPromo);
                          
                          // Se está dentro das 24h após expiração, mostra promo tachado e normal
                          if (isWithin24Hours) {
                            return (
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative', marginTop: '8px', textAlign: 'center' }}>
                                <span style={{ 
                                  textDecoration: 'line-through', 
                                  color: '#666', 
                                  fontSize: '1.8rem',
                                  fontWeight: '500',
                                  marginBottom: '2px'
                                }}>
                                  <span className="currency-symbol" style={{ textDecoration: 'none', display: 'inline-block' }}>{currencySymbol}</span>
                                  <span className="amount">{formattedPromo.replace(/[^\d.,]/g, '')}</span>
                                </span>
                                <span style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#BA824F', display: 'flex', gap: '8px', alignItems: 'center' }}>
                                  <span className="currency-symbol">{currencySymbol}</span>
                                  <span className="amount">{formattedOriginal.replace(/[^\d.,]/g, '')}</span>
                                </span>
                              </div>
                            );
                          }
                          
                          // Promoção ativa: mostra original tachado e promocional
                          return (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative', marginTop: '8px', textAlign: 'center' }}>
                              <span style={{ 
                                textDecoration: 'line-through', 
                                color: '#666', 
                                fontSize: '1.8rem',
                                fontWeight: '500',
                                marginBottom: '2px'
                              }}>
                                <span className="currency-symbol" style={{ textDecoration: 'none', display: 'inline-block' }}>{currencySymbol}</span>
                                <span className="amount">{formattedOriginal.replace(/[^\d.,]/g, '')}</span>
                              </span>
                              <span style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#BA824F', display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <span className="currency-symbol">{currencySymbol}</span>
                                <span className="amount">{formattedPromo.replace(/[^\d.,]/g, '')}</span>
                              </span>
                                                          </div>
                          );
                        }
                        
                        // Sem promoção, mostra preço normal
                        const value = Number(planoApi.valorPLANO);
                        const convertedValue = value * exchangeRate;
                        const formattedValue = new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: currency,
                        }).format(convertedValue);
                        
                        // Usar o símbolo da moeda do contexto
                        return (
                          <span>
                            <span className="currency-symbol">{currencySymbol}</span>
                            <span className="amount">{formattedValue.replace(/[^\d.,]/g, '')}</span>
                          </span>
                        );
                      })()}
                    </div>
                    {planoApi.cupons && Array.isArray(planoApi.cupons) && planoApi.cupons.length > 0 && !timeLeft.expired && (
                      <button
                        className="coupon-btn"
                        onClick={() => {
                          const couponCode = planoApi.cupons[0].codigoCupomSTR;
                          setPromotionCode(couponCode);
                          const token = localStorage.getItem('auth_token');
                          if (!token) {
                            goToCadastro();
                            return;
                          }
                          handlePlanSelection(planoApi, index, couponCode);
                        }}
                      >
                        <div className="coupon-icon">
                          🎁
                        </div>
                        <div className="coupon-content">
                          <span className="coupon-label">
                            Use o cupom
                          </span>
                          <span className="coupon-code">
                            {planoApi.cupons[0].codigoCupomSTR}
                          </span>
                        </div>
                      </button>
                    )}
                    <div className="plan-card-content">
                      <ul className="features">
                        {(() => {
                          const coerceFeatureToString = (item) => {
                            if (typeof item === 'string') return item;
                            if (item == null) return '';
                            if (typeof item === 'number' || typeof item === 'boolean') return String(item);
                            if (typeof item === 'object') {
                              const candidate =
                                item.descritivoPLANO ??
                                item.descritivo ??
                                item.texto ??
                                item.label ??
                                item.value;
                              if (typeof candidate === 'string' || typeof candidate === 'number') return String(candidate);
                              return '';
                            }
                            return '';
                          };

                          const qtyFromTitle = (() => {
                            const text = String(planoApi?.nomePLANO || '');
                            const m = text.match(/(\d{1,3}(?:\.\d{3})*)/);
                            if (!m) return undefined;
                            const normalized = m[1].replace(/\./g, '');
                            const value = Number(normalized);
                            return Number.isNaN(value) ? undefined : value;
                          })();

                          const defaultQty = (() => {
                            const days = Number(planoApi?.tempoPLANO || 0);
                            const name = String(planoApi?.nomePLANO || '').toLowerCase();
                            const value = Number(planoApi?.valorPLANO || 0);
                            const isYear = days === 365 || name.includes('12 meses') || name.includes('365 dias') || name.includes('1 ano');
                            // Only the 365-day plan with value >= 3000 should show 12 properties
                            const isPremiumYearPlan = isYear && value >= 3000;
                            if (days === 30 || name.includes('1 mês') || name.includes('30 dias')) return 1;
                            if (days === 90 || name.includes('3 meses') || name.includes('90 dias')) return 1;
                            if (days === 180 || name.includes('6 meses') || name.includes('180 dias')) return 1;
                            if (isPremiumYearPlan) return 12;
                            if (isYear) return 1;
                            return undefined;
                          })();

                          const qtyFromApi = Number(planoApi?.quantidadePLANO ?? 0);
                          const publishQty = (Number.isFinite(qtyFromApi) && qtyFromApi > 0)
                            ? qtyFromApi
                            : (Number.isFinite(defaultQty) && defaultQty > 0 ? defaultQty : (qtyFromTitle ?? 1));
                          const publishQtyLabel = Number.isFinite(publishQty)
                            ? publishQty.toLocaleString('pt-BR')
                            : publishQty;

                          const publishQtyText = publishQty === 1 ? 'imóvel' : 'imóveis';

                          const baseRaw = (() => {
                            const raw = planoApi.descritivosPLANO;
                            if (Array.isArray(raw)) return raw;
                            if (typeof raw === 'string') {
                              try {
                                const parsed = JSON.parse(raw);
                                return Array.isArray(parsed) ? parsed : (parsed && typeof parsed === 'object' ? Object.values(parsed) : []);
                              } catch {
                                return raw.trim() ? [raw] : [];
                              }
                            }
                            if (raw && typeof raw === 'object') return Object.values(raw);
                            return [];
                          })();
                          const base = baseRaw
                            .map(coerceFeatureToString)
                            .map((s) => {
                              if (typeof s !== 'string') return s;
                              return s
                                .replace(/(&nbsp;|&#160;|\u00a0|£nbsp;)/gi, ' ')
                                .replace(/\s{2,}/g, ' ')
                                .trim();
                            })
                            .filter((s) => {
                              if (!s) return false;
                              if (typeof s !== 'string') return true;
                              const days = Number(planoApi?.tempoPLANO || 0);
                              const name = String(planoApi?.nomePLANO || '').toLowerCase();
                              const isOneMonth = days === 30 || name.includes('1 mês') || name.includes('30 dias');
                              if (isOneMonth && s.toLowerCase().includes('fale com o nosso time')) return false;
                              return true;
                            });

                          const buildOrderedFeriasFeatures = () => {
                            const days = Number(planoApi?.tempoPLANO || 0);
                            const name = String(planoApi?.nomePLANO || '').toLowerCase();
                            const isOneMonth = days === 30 || name.includes('1 mês') || name.includes('30 dias');

                            const find = (predicate) => base.find((it) => typeof it === 'string' && predicate(it.toLowerCase()));

                            const existingPeriod = find((s) => s.includes('período de tempo'));
                            const existingPublish = find((s) => s.includes('publique até'));
                            const existingCambio = find((s) => s.includes('câmbio'));
                            const existingIva = find((s) => /\biva\b/.test(s));
                            const existingVisibilidade = find((s) => s.includes('visibilidade') || s.includes('50 países'));
                            const existingContrato = find((s) => s.includes('contrato') || s.includes('obrigatoriedade'));
                            const existingComissoes = find((s) => s.includes('comissões'));
                            const existingTeste = find((s) => s.includes('teste rápido') || s.includes('tração'));

                            const ordered = [];

                            if (existingPeriod) {
                              ordered.push(existingPeriod.replace(/Dias/gi, 'dias').replace(/(\d+)\s+dias/gi, '$1\u00a0dias'));
                            }

                            if (existingPublish) {
                              ordered.push(`Publique até ${publishQtyLabel}\u00a0${publishQtyText}`);
                            }

                            if (existingCambio) {
                              ordered.push(existingCambio);
                            }

                            if (existingIva) {
                              ordered.push(existingIva);
                            }

                            if (existingVisibilidade) {
                              ordered.push(existingVisibilidade);
                            }

                            if (existingContrato) {
                              ordered.push(existingContrato);
                            }

                            base.forEach((it) => {
                              if (typeof it !== 'string') return;
                              const lower = it.toLowerCase();
                              if (lower.includes('período de tempo')) return;
                              if (lower.includes('publique até')) return;
                              if (lower.includes('câmbio')) return;
                              if (/\biva\b/.test(lower)) return;
                              if (lower.includes('visibilidade') || lower.includes('50 países')) return;
                              if (lower.includes('contrato') || lower.includes('obrigatoriedade')) return;
                              if (lower.includes('teste rápido') || lower.includes('tração')) return;
                              if (lower.includes('comissões')) return;
                              ordered.push(it);
                            });

                            if (isOneMonth && existingTeste) {
                              ordered.push(existingTeste);
                            }

                            if (existingComissoes) {
                              ordered.push(existingComissoes);
                            }

                            return ordered;
                          };

                          if (planType === 'ferias') {
                            return buildOrderedFeriasFeatures().map((feature, i) => (
                              <li key={i}>{feature}</li>
                            ));
                          }

                          const corrected = base.map((item) => {
                            if (typeof item === 'string') {
                              const lower = item.toLowerCase();
                              if (lower.includes('publique até')) {
                                return `Publique até ${publishQtyLabel}\u00a0${publishQtyText}`;
                              }
                              if (lower.includes('período de tempo')) {
                                return item
                                  .replace(/Dias/gi, 'dias')
                                  .replace(/(\d+)\s+dias/gi, '$1\u00a0dias');
                              }
                            }
                            return item;
                          });

                          // Move "Sem comissões" to the end for professional and particular plans
                          const ordered = [];
                          const comissoesItem = corrected.find((item) => typeof item === 'string' && item.toLowerCase().includes('comissões'));
                          
                          corrected.forEach((item) => {
                            if (typeof item === 'string' && item.toLowerCase().includes('comissões')) {
                              return; // Skip comissões item, will add at the end
                            }
                            ordered.push(item);
                          });
                          
                          if (comissoesItem) {
                            ordered.push(comissoesItem);
                          }

                          return ordered.map((feature, i) => (
                            <li key={i}>{feature}</li>
                          ));
                        })()}
                      </ul>
                    </div>
                    <div className="plan-card-footer">
                      {planoApi.fallbackCTA ? (
                        <button
                          className="plan-button outline"
                          onClick={openContactModal}
                        >
                          Falar com especialista
                        </button>
                      ) : (() => {
                        const isTimerActive = timeLeft.days > 0 || timeLeft.hours > 0 || timeLeft.minutes > 0 || timeLeft.seconds > 0;
                        const isWithin24Hours = promotionEndedTimestamp && (Date.now() - promotionEndedTimestamp) < (24 * 60 * 60 * 1000);
                        const isPromotionActive = isTimerActive && !isWithin24Hours;
                        const valueBase = (Number(planoApi?.promoPLANO || 0) > 0 && isPromotionActive)
                          ? Number(planoApi.promoPLANO)
                          : (Number(planoApi?.valorPromocionalPLANO || 0) > 0 && isPromotionActive
                            ? Number(planoApi.valorPromocionalPLANO)
                            : Number(planoApi?.valorPLANO || 0));
                        const isFreeItem = valueBase === 0;
                        const isThisPlanProcessing = processingPlanIndex === index;
                        return (
                          <button
                            className={`plan-button ${isThisPlanProcessing ? 'processing' : ''}`}
                            onClick={() => {
                              const token = localStorage.getItem('auth_token');
                              if (!token) {
                                goToCadastro();
                                return;
                              }
                              // Check if user is professional and trying to access free plan
                              if (isFreeItem && userRole === 'PROFISSIONAL') {
                                setPlanUsedPopupType('professional');
                                setShowPlanUsedPopup(true);
                                return;
                              }
                              const alreadyRedeemed = freePlanRedeemed;
                              if (isFreeItem && alreadyRedeemed) {
                                setPlanUsedPopupType('redeemed');
                                setShowPlanUsedPopup(true);
                                return;
                              }
                              handlePlanSelection(planoApi, index);
                            }}
                            disabled={isThisPlanProcessing}
                          >
                            {isThisPlanProcessing ? (
                              <>
                                <span className="button-text">Processando...</span>
                                <span className="button-loader"></span>
                              </>
                            ) : (
                              isFreeItem && userRole === 'PROFISSIONAL'
                                ? 'Plano Indisponível'
                                : isFreeItem && freePlanRedeemed
                                  ? 'Plano Gratuito já resgatado'
                                  : 'Escolher Plano'
                            )}
                          </button>
                        );
                      })()}
                    </div>
                  </div>
                </SwiperSlide>
              ));
            })()}

            {planType === 'professional' && ['30d', '12m'].includes(billingPeriod) && (
              <SwiperSlide key="pro-max-static">
                <div className="plan-card promax-card" aria-label={billingPeriod === '30d' ? 'Plano Pro Max' : 'Plano Business Plus'}>
                  <div className="promax-header">{billingPeriod === '30d' ? 'PRO MAX' : 'BUSINESS +'}</div>
                  <div className="plan-card-content">
                    <div className="promax-body">
                      {billingPeriod === '30d' ? (
                      <ul className="promax-features">
                        <li>Periodo de tempo 30 dias</li>
                        <li>Condições comerciais ajustadas ao volume</li>
                        <li>Para grandes operações</li>
                        <li>Visibilidade em + de 50 países</li>
                        <li>Sem obrigatoriedade de contrato</li>
                        <li>Mais imóveis</li>
                        <li>Suporte prioritário</li>
                        <li>Atendimento dedicado</li>
                        <li><strong style={{ color: 'black', fontWeight: 'bold', textTransform: 'uppercase' }}>MENOS CUSTOS</strong></li>
                        
                      </ul>
                      ) : (
                      <ul className="promax-features">
                        <li>Periodo de tempo 365 dias</li>
                        <li>Solução completa para volume elevado de imóveis</li>
                        <li>Máxima capacidade de publicação</li>
                        <li>Visibilidade em + de 50 países</li>
                        <li>Integrações e funcionalidades avançadas</li>
                        <li>Condições adaptadas às necessidades da sua empresa</li>
                        <li>Sem obrigatoriedade de contrato</li>
                        <li style={{ whiteSpace: 'nowrap' }}>Mais imóveis - <strong style={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>MENOS CUSTOS</strong></li>
                        <li>Suporte prioritário</li>
                        <li>Atendimento dedicado</li>
                      </ul>
                      )}
                    </div>
                  </div>
                  <div className="plan-card-footer">
                    <button
                      className="plan-button promax-button"
                      onClick={handleCustomProposalClick}
                    >
                      Solicitar Proposta Personalizada
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            )}
          </Swiper>

          {/* --- BLOCOS PROMOCIONAIS ABAIXO DOS PLANOS --- */}
          {planType === 'ferias' && (
            <div style={{
              background: 'linear-gradient(135deg, #134946 0%, #1a635f 100%)',
              color: '#BA824F',
              borderRadius: 20,
              margin: '20px auto 16px',
              padding: '24px 20px',
              maxWidth: 800,
              textAlign: 'center',
              boxShadow: '0 4px 16px rgba(19, 73, 70, 0.12)',
            }}>
              <h2 style={{fontWeight: 700, fontSize: '1.5rem', marginBottom: 16, color: '#BA824F'}}>
                PLANOS DE FÉRIAS
              </h2>
              <p style={{color: 'white', fontSize: 16, margin: '20px 0 12px'}}>
                Anuncie o seu imóvel de férias e alcance milhões de viajantes em todo o mundo!
              </p>
              <p style={{color: '#FFFF', fontSize: 14, marginBottom: 20}}>
                Descubra as melhores opções para anunciar o seu imóvel de férias e comece a rentabilizar o seu patrimônio agora mesmo.
              </p>
            </div>
          )}

          <div style={{
            background: 'linear-gradient(135deg, #134946 0%, #1a635f 100%)',
            color: '#BA824F',
            borderRadius: 20,
            margin: '20px auto 16px',
            padding: '24px 20px',
            maxWidth: 800,
            textAlign: 'center',
            boxShadow: '0 4px 16px rgba(19, 73, 70, 0.12)',
          }}>
            <h2 style={{fontWeight: 700, fontSize: '1.5rem', marginBottom: 16, color: '#BA824F'}}>
              NÃO ENCONTROU UM PLANO A SUA MEDIDA?
            </h2>
            <button style={{
              color: '#BA824F',
              borderRadius: 24,
              padding: '8px 24px',
              fontWeight: 600,
              fontSize: 22,
              marginTop: 6,
              boxShadow: 'none',
              cursor: 'default',
            }} disabled>Já pensou em dar um impulso extra aos seus anúncios?</button>
            <p style={{color: 'white', fontSize: 16, margin: '20px 0 12px'}}>
              Coloque os seus imóveis em destaque por 30 dias<br/>
              e beneficie de tarifas exclusivas e mais vantajosas do mercado mundial!
            </p>
            <h3 style={{color: '#BA824F', fontWeight: 500, marginBottom: 12}}>E se ainda assim procura algo diferente... Criamos um plano totalmente personalizado para si.</h3>
            <p style={{color: '#FFFF', fontSize: 14, marginBottom: 20}}>
              Basta enviar uma mensagem através do formulário e entraremos em contacto o mais breve possível
            </p>
            <button 
              style={{
                background: '#BA824F',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                padding: '12px 0',
                fontWeight: 600,
                fontSize: 16,
                width: '100%',
                maxWidth: 400,
                margin: '0 auto',
                display: 'block',
                boxShadow: 'none',
                cursor: 'pointer',
              }}
              onClick={() => window.location.href = '/contact'}
            >Ir para o formulário de contacto</button>
          </div>

          
          <StatsSection />
          <PlanFeatures />
        </div>
        {showLoginModal && (
          <LoginModal 
            onClose={() => setShowLoginModal(false)}
            extraMessage="Você precisa estar logado ou cadastrado para escolher um plano."
          />
        )}
        {showContactModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
          }}>
            <div style={{
              background: '#fff',
              borderRadius: 20,
              padding: '40px',
              maxWidth: '700px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
            }}>
              <button
                onClick={closeContactModal}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  background: 'transparent',
                  border: 'none',
                  fontSize: '28px',
                  cursor: 'pointer',
                  color: '#999',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f5f5f5';
                  e.target.style.color = '#333';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = '#999';
                }}
              >
                ×
              </button>
              
              {contactFormSubmitted ? (
                <div style={{ textAlign: 'center', padding: '60px 40px' }}>
                  <div style={{ 
                    width: '80px', 
                    height: '80px', 
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                    fontSize: '40px',
                    color: '#fff'
                  }}>✓</div>
                  <h2 style={{ color: '#34574A', marginBottom: '12px', fontSize: '24px' }}>Obrigado pelo seu interesse na JoviPlanet.</h2>
                  <p style={{ color: '#666', lineHeight: '1.8', fontSize: '16px' }}>
                    A nossa equipa irá analisar o seu portfólio e responder brevemente.
                  </p>
                </div>
              ) : (
                <>
                  <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <h2 style={{ color: '#34574A', marginBottom: '8px', fontSize: '28px', fontWeight: '700' }}>
                      Solicite sua Proposta Personalizada
                    </h2>
                    <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.6' }}>
                      Plano {billingPeriod === '30d' ? 'Pro Max' : 'Business +'} ({billingPeriod === '30d' ? 'Mensal' : 'Anual'})
                    </p>
                    <p style={{ color: '#BA824F', fontSize: '14px', marginTop: '8px', fontWeight: '500' }}>
                      Condições comerciais ajustadas ao volume do seu negócio
                    </p>
                  </div>
                  
                  <form onSubmit={handleContactSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#34574A', fontSize: '14px' }}>
                          Nome *
                        </label>
                        <input
                          type="text"
                          name="nome"
                          value={contactForm.nome}
                          onChange={handleContactInputChange}
                          required
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: '2px solid #e5e5e5',
                            borderRadius: '10px',
                            fontSize: '15px',
                            transition: 'border-color 0.2s'
                          }}
                          onFocus={(e) => e.target.style.borderColor = '#34574A'}
                          onBlur={(e) => e.target.style.borderColor = '#e5e5e5'}
                        />
                      </div>
                      
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#34574A', fontSize: '14px' }}>
                          E-mail *
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={contactForm.email}
                          onChange={handleContactInputChange}
                          required
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: '2px solid #e5e5e5',
                            borderRadius: '10px',
                            fontSize: '15px',
                            transition: 'border-color 0.2s'
                          }}
                          onFocus={(e) => e.target.style.borderColor = '#34574A'}
                          onBlur={(e) => e.target.style.borderColor = '#e5e5e5'}
                        />
                      </div>
                    </div>
                    
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#34574A', fontSize: '14px' }}>
                          Telefone *
                        </label>
                        <input
                          type="tel"
                          name="telefone"
                          value={contactForm.telefone}
                          onChange={handleContactInputChange}
                          required
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: '2px solid #e5e5e5',
                            borderRadius: '10px',
                            fontSize: '15px',
                            transition: 'border-color 0.2s'
                          }}
                          onFocus={(e) => e.target.style.borderColor = '#34574A'}
                          onBlur={(e) => e.target.style.borderColor = '#e5e5e5'}
                        />
                      </div>
                      
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#34574A', fontSize: '14px' }}>
                          Nº de Imóveis *
                        </label>
                        <input
                          type="number"
                          name="numImoveis"
                          value={contactForm.numImoveis}
                          onChange={handleContactInputChange}
                          required
                          min="1"
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            border: '2px solid #e5e5e5',
                            borderRadius: '10px',
                            fontSize: '15px',
                            transition: 'border-color 0.2s'
                          }}
                          onFocus={(e) => e.target.style.borderColor = '#34574A'}
                          onBlur={(e) => e.target.style.borderColor = '#e5e5e5'}
                        />
                      </div>
                    </div>
                    
                    <div>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#34574A', fontSize: '14px' }}>
                        País *
                      </label>
                      <input
                        type="text"
                        name="pais"
                        value={contactForm.pais}
                        onChange={handleContactInputChange}
                        required
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: '2px solid #e5e5e5',
                          borderRadius: '10px',
                          fontSize: '15px',
                          transition: 'border-color 0.2s'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#34574A'}
                        onBlur={(e) => e.target.style.borderColor = '#e5e5e5'}
                      />
                    </div>
                    
                    <div>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#34574A', fontSize: '14px' }}>
                        Assunto *
                      </label>
                      <input
                        type="text"
                        name="assunto"
                        value={contactForm.assunto || (billingPeriod === '30d' ? 'Proposta Plano Pro Max' : 'Proposta Plano Business +')}
                        onChange={handleContactInputChange}
                        required
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: '2px solid #e5e5e5',
                          borderRadius: '10px',
                          fontSize: '15px',
                          transition: 'border-color 0.2s'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#34574A'}
                        onBlur={(e) => e.target.style.borderColor = '#e5e5e5'}
                      />
                    </div>
                    
                    <div>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#34574A', fontSize: '14px' }}>
                        Mensagem
                      </label>
                      <textarea
                        name="mensagem"
                        value={contactForm.mensagem}
                        onChange={handleContactInputChange}
                        rows="4"
                        placeholder="Conte-nos mais sobre as suas necessidades..."
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          border: '2px solid #e5e5e5',
                          borderRadius: '10px',
                          fontSize: '15px',
                          resize: 'vertical',
                          transition: 'border-color 0.2s'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#34574A'}
                        onBlur={(e) => e.target.style.borderColor = '#e5e5e5'}
                      />
                    </div>
                    
                    <div style={{ display: 'flex', gap: '16px', marginTop: '12px' }}>
                      <button
                        type="button"
                        onClick={closeContactModal}
                        disabled={isSubmittingContact}
                        style={{
                          flex: 1,
                          padding: '14px 24px',
                          border: '2px solid #e5e5e5',
                          borderRadius: '10px',
                          background: '#fff',
                          cursor: isSubmittingContact ? 'not-allowed' : 'pointer',
                          fontSize: '15px',
                          fontWeight: '600',
                          color: '#666',
                          transition: 'all 0.2s'
                        }}
                      >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        disabled={isSubmittingContact}
                        style={{
                          flex: 1,
                          padding: '14px 24px',
                          border: 'none',
                          borderRadius: '10px',
                          background: 'linear-gradient(135deg, #34574A 0%, #4a7a6f 100%)',
                          color: '#fff',
                          cursor: isSubmittingContact ? 'not-allowed' : 'pointer',
                          fontSize: '15px',
                          fontWeight: '600',
                          opacity: isSubmittingContact ? 0.6 : 1,
                          transition: 'all 0.2s',
                          boxShadow: '0 4px 12px rgba(52, 87, 74, 0.3)'
                        }}
                      >
                        {isSubmittingContact ? 'Enviando...' : 'Solicitar Proposta'}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        )}
        {showUrgencyModal && !timeLeft.expired && isTargetPlan && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.6)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            animation: 'fadeIn 0.3s ease-out'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #134946 0%, #1a635f 100%)',
              borderRadius: 20,
              padding: '40px 30px',
              maxWidth: '500px',
              width: '100%',
              textAlign: 'center',
              position: 'relative',
              boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
              animation: 'slideUp 0.3s ease-out'
            }}>
              <button
                onClick={() => {
                  setShowUrgencyModal(false);
                  setUserClosedUrgencyModal(true);
                }}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#fff',
                  width: '35px',
                  height: '35px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                }}
              >
                ×
              </button>

              <div style={{
                fontSize: '48px',
                marginBottom: '16px'
              }}>
                ⏰
              </div>

              <h2 style={{
                color: '#BA824F',
                fontSize: '28px',
                fontWeight: '700',
                marginBottom: '16px',
                lineHeight: '1.3'
              }}>
                Não deixes passar esta oportunidade
              </h2>

              {/* Temporizador */}
              {!isSoldOut && isTargetPlan && (timeLeft.days > 0 || timeLeft.hours > 0 || timeLeft.minutes > 0 || timeLeft.seconds > 0) && (
                <>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginBottom: '24px',
                    flexWrap: 'wrap'
                  }}>
                    {timeLeft.days > 0 && (
                    <div style={{
                      textAlign: 'center',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      minWidth: '60px'
                    }}>
                      <div style={{
                        fontSize: '24px',
                        fontWeight: '700',
                        color: '#fff',
                        lineHeight: '1'
                      }}>
                        {String(timeLeft.days).padStart(2, '0')}
                      </div>
                      <div style={{
                        fontSize: '12px',
                        color: '#fff',
                        fontWeight: '500',
                        textTransform: 'uppercase',
                        marginTop: '4px'
                      }}>
                        Dias
                      </div>
                    </div>
                  )}
                  
                  <div style={{
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    minWidth: '60px'
                  }}>
                    <div style={{
                      fontSize: '24px',
                      fontWeight: '700',
                      color: '#fff',
                      lineHeight: '1'
                    }}>
                      {String(timeLeft.hours).padStart(2, '0')}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#fff',
                      fontWeight: '500',
                      textTransform: 'uppercase',
                      marginTop: '4px'
                    }}>
                      Horas
                    </div>
                  </div>
                  
                  <div style={{
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    minWidth: '60px'
                  }}>
                    <div style={{
                      fontSize: '24px',
                      fontWeight: '700',
                      color: '#fff',
                      lineHeight: '1'
                    }}>
                      {String(timeLeft.minutes).padStart(2, '0')}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#fff',
                      fontWeight: '500',
                      textTransform: 'uppercase',
                      marginTop: '4px'
                    }}>
                      Min
                    </div>
                  </div>
                  
                  <div style={{
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    minWidth: '60px'
                  }}>
                    <div style={{
                      fontSize: '24px',
                      fontWeight: '700',
                      color: '#fff',
                      lineHeight: '1'
                    }}>
                      {String(timeLeft.seconds).padStart(2, '0')}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#fff',
                      fontWeight: '500',
                      textTransform: 'uppercase',
                      marginTop: '4px'
                    }}>
                      Seg
                    </div>
                  </div>
                </div>
                </>
              )}
              
              {!isSoldOut && (
                <>
                  <p style={{
                    color: '#fff',
                    fontSize: '20px',
                    fontWeight: '600',
                    marginBottom: '20px'
                  }}>
                    Garanta já o seu Plano
                  </p>
                  
                  {planType === 'ferias' && (
                    <button
                    onClick={() => {
                  setShowUrgencyModal(false);
                  setUserClosedUrgencyModal(true);
                }}
                    style={{
                      background: '#e0e0e0',
                      border: 'none',
                      borderRadius: 12,
                      padding: '16px',
                      marginBottom: '24px',
                      width: '100%',
                      cursor: 'pointer'
                    }}
                  >
                    <p style={{
                      color: '#000',
                      fontSize: '18px',
                      fontWeight: '600',
                      fontStyle: 'italic',
                      margin: 0
                    }}>
                      SEM COMISSÕES<br/>FIQUE COM 100% DAS SUAS RESERVAS
                    </p>
                  </button>
                  )}
                  
                  {planType === 'professional' && (
                    <button
                    onClick={() => {
                  setShowUrgencyModal(false);
                  setUserClosedUrgencyModal(true);
                }}
                    style={{
                      background: '#e0e0e0',
                      border: 'none',
                      borderRadius: 12,
                      padding: '16px',
                      marginBottom: '24px',
                      width: '100%',
                      cursor: 'pointer'
                    }}
                  >
                    <p style={{
                      color: '#000',
                      fontSize: '18px',
                      fontWeight: '600',
                      fontStyle: 'italic',
                      margin: 0
                    }}>
                      SEM COMISSÕES. APENAS CRESCIMENTO
                    </p>
                  </button>
                  )}
                </>
              )}
              
              <button
                onClick={() => {
                  setShowUrgencyModal(false);
                  setUserClosedUrgencyModal(true);
                }}
                style={{
                  background: '#BA824F',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 12,
                  padding: '16px 32px',
                  fontWeight: '700',
                  fontSize: '18px',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 12px rgba(186, 130, 79, 0.4)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(186, 130, 79, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(186, 130, 79, 0.4)';
                }}
              >
                Ver Planos
              </button>
            </div>
          </div>
        )}

        {/* Modal quando o tempo expirar */}
        {showTimeExpiredModal && ((planType === 'professional' && billingPeriod === '12m') || planType === 'ferias') && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.6)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            animation: 'fadeIn 0.3s ease-out'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #c62828 0%, #e53935 100%)',
              borderRadius: 20,
              padding: '40px 30px',
              maxWidth: '500px',
              width: '100%',
              textAlign: 'center',
              position: 'relative',
              boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
              animation: 'slideUp 0.3s ease-out'
            }}>
              <button
                onClick={() => {
                  setShowTimeExpiredModal(false);
                  setUserClosedTimeExpiredModal(true);
                }}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#fff',
                  width: '35px',
                  height: '35px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                }}
              >
                ×
              </button>

              <div style={{
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <img src="/favicon-32.png" alt="JoviPlanet" style={{ width: '48px', height: '48px' }} />
              </div>

              <h2 style={{
                color: '#fff',
                fontSize: '24px',
                fontWeight: '700',
                marginBottom: '20px',
                lineHeight: '1.3'
              }}>
                {promocao?.tituloExpiradoPROMOCAO || 'O tempo acabou!'}
              </h2>

              <p style={{
                color: '#fff',
                fontSize: '16px',
                marginBottom: '24px',
                lineHeight: '1.5'
              }}>
                {(promocao?.mensagemExpiradoPROMOCAO || 'FOI PENA TERES PERDIDO ESTA COMPRA\nCOM ESTES PREÇOS, MAS BREVEMENTE,\nTEREMOS MAIS NOVIDADES.\nFICA ATENTO')
                  .split('\n')
                  .map((linha, i, arr) => (
                    <React.Fragment key={i}>{linha}{i < arr.length - 1 && <br />}</React.Fragment>
                  ))}
              </p>

              <button
                onClick={() => {
                  setShowTimeExpiredModal(false);
                  setUserClosedTimeExpiredModal(true);
                }}
                style={{
                  background: '#fff',
                  color: '#c62828',
                  border: 'none',
                  borderRadius: 12,
                  padding: '16px 32px',
                  fontWeight: '700',
                  fontSize: '18px',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
                }}
              >
                OK
              </button>
            </div>
          </div>
        )}

        {/* Pop-up de milestones - DESATIVADO POR ENQUANTO
        {showMilestonePopup && ((planType === 'professional' && billingPeriod === '12m') || planType === 'ferias') && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.6)',
            zIndex: 4000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            animation: 'fadeIn 0.3s ease-out'
          }}>
            <div style={{
              background: slotsLeft === 0 
                ? 'linear-gradient(135deg, #c62828 0%, #e53935 100%)'
                : 'linear-gradient(135deg, #134946 0%, #1a635f 100%)',
              borderRadius: 20,
              padding: '40px 30px',
              maxWidth: '500px',
              width: '100%',
              textAlign: 'center',
              position: 'relative',
              boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
              animation: 'slideUp 0.3s ease-out'
            }}>
              <button
                onClick={() => setShowMilestonePopup(false)}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#fff',
                  width: '35px',
                  height: '35px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                }}
              >
                ×
              </button>
              
              <div style={{
                fontSize: slotsLeft === 0 ? '48px' : '52px',
                marginBottom: '16px'
              }}>
                {slotsLeft === 0 ? '😢' : '⚡'}
              </div>
              
              <h2 style={{
                color: slotsLeft === 0 ? '#fff' : '#BA824F',
                fontSize: slotsLeft === 0 ? '22px' : '28px',
                fontWeight: '700',
                marginBottom: '20px',
                lineHeight: '1.4',
                whiteSpace: 'pre-line'
              }}>
                {milestoneMessage}
              </h2>
              
              <button
                onClick={() => setShowMilestonePopup(false)}
                style={{
                  background: slotsLeft === 0 ? '#fff' : '#BA824F',
                  color: slotsLeft === 0 ? '#c62828' : '#fff',
                  border: 'none',
                  borderRadius: 12,
                  padding: '14px 32px',
                  fontWeight: '700',
                  fontSize: '16px',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'all 0.2s',
                  boxShadow: slotsLeft === 0 
                    ? '0 4px 12px rgba(0,0,0,0.3)'
                    : '0 4px 12px rgba(186, 130, 79, 0.4)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = slotsLeft === 0 
                    ? '0 6px 16px rgba(0,0,0,0.4)'
                    : '0 6px 16px rgba(186, 130, 79, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = slotsLeft === 0 
                    ? '0 4px 12px rgba(0,0,0,0.3)'
                    : '0 4px 12px rgba(186, 130, 79, 0.4)';
                }}
              >
                {slotsLeft === 0 ? 'OK' : 'Continuar'}
              </button>
            </div>
          </div>
        )}
        */}

        {showPlanUsedPopup && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.6)',
            zIndex: 5000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            animation: 'fadeIn 0.3s ease-out'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #134946 0%, #1a635f 100%)',
              borderRadius: 20,
              padding: '40px 30px',
              maxWidth: '500px',
              width: '100%',
              textAlign: 'center',
              position: 'relative',
              boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
              animation: 'slideUp 0.3s ease-out'
            }}>
              <button
                onClick={() => setShowPlanUsedPopup(false)}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#fff',
                  width: '35px',
                  height: '35px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                }}
              >
                ×
              </button>

              <div style={{
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <img src="/favicon-32.png" alt="JoviPlanet" style={{ width: '48px', height: '48px' }} />
              </div>

              <h2 style={{
                color: '#BA824F',
                fontSize: '24px',
                fontWeight: '700',
                marginBottom: '20px',
                lineHeight: '1.4'
              }}>
                {planUsedPopupType === 'professional' ? 'Plano Indisponível' : 'Plano Gratuito'}
              </h2>

              <p style={{
                color: '#fff',
                fontSize: '16px',
                marginBottom: '24px',
                lineHeight: '1.5'
              }}>
                {planUsedPopupType === 'professional'
                  ? 'O Plano Gratuito está disponível apenas para contas Particulares.'
                  : 'Já utilizou este plano. Poderá voltar a ativá-lo dentro de 6 meses.'
                }
              </p>

              <button
                onClick={() => setShowPlanUsedPopup(false)}
                style={{
                  background: '#BA824F',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 12,
                  padding: '14px 32px',
                  fontWeight: '700',
                  fontSize: '16px',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 12px rgba(186, 130, 79, 0.4)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 16px rgba(186, 130, 79, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(186, 130, 79, 0.4)';
                }}
              >
                OK
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Plans;
